import { Component, OnInit } from '@angular/core';
import { HaloLoaderService } from 'src/app/core/halo-loader/halo-loader.service';
import { RootScopeDeclare } from 'src/app/core/rootscope-declare';
import { FacilityObject } from 'src/app/core/services/facility.model';
import { FacilityService } from 'src/app/core/services/facility.service';
import { RootScopeService } from 'src/app/core/shared-service/root-scope.service';
import { CommonUtil } from 'src/app/core/Utils/common-util';
import { SubscriptionService } from '../../services/subscription.service';
import { environment } from 'src/environments/environment';
import { FlagObject } from 'src/app/core/halo-tips/halo-tips.model';
import { Router } from '@angular/router';
import { AmplitudeAnalyticsService } from 'src/app/core/services/amplitude-analytics.service';

@Component({
  selector: 'app-digital-coach',
  templateUrl: './digital-coach.component.html',
  styleUrls: ['./digital-coach.component.css']
})
export class DigitalCoachComponent implements OnInit {
  private _currentFacility: FacilityObject;
  rootScopeData: RootScopeDeclare;
  popupData: any = {};
  constructor(
    private router: Router,
    public facilityService: FacilityService,
    public commonUtil: CommonUtil,
    private _amplitudeAnalytics: AmplitudeAnalyticsService,
    private _loader: HaloLoaderService,
    private _subscriptionService: SubscriptionService,
    private _rootScopeService: RootScopeService
  ) { }

  async ngOnInit() {
    try {
      this._currentFacility = this.facilityService.selectedFacility();
      this.popupData = this.facilityService.getAnnouncements() || {};
      if (!this._currentFacility?.summary) {
        this._loader.startProcess();
        await this.facilityService.get();
        this._loader.endProcess();
        this._currentFacility = this.facilityService.selectedFacility();
      }
      this.getRootScopeData();
      if (this._currentFacility?.summary &&
        this._currentFacility.summary?.facilityRights &&
        this._currentFacility.summary.facilityRights?.digitalCoach &&
        this._currentFacility.summary.facilityRights.digitalCoach === 'true') {
        this.goToDigitalCoachPage();
      }
    } catch (error) {
      console.log('API failed');
    }
  }

  getRootScopeData(): void {
    this._rootScopeService.getRootScope().subscribe((rootScopeData) => (this.rootScopeData = rootScopeData));
  }

  goToDigitalCoachPage() {
    const flagsToUpdate: FlagObject = {};
    if (this.popupData
      && this.popupData.showDigitalCoachDashboardBanner) {
      flagsToUpdate['showDigitalCoachDashboardBanner'] = false;
      this.rootScopeData.popupData.showDigitalCoachDashboardBanner = false;
      this._rootScopeService.updateRootScope(this.rootScopeData);
    }
    if (Object.keys(flagsToUpdate).length > 0)
      this.facilityService.updatedFacilityPreferenceForUser2(flagsToUpdate);
    this._rootScopeService.updateRootScope(this.rootScopeData);
    this._subscriptionService.getJWTTokenFromAPI(this.rootScopeData.currentUser.userId, this._currentFacility.facilityId, 'digital_coach').subscribe(
      data => {
        let pearUrl = environment.pearStudioURL;
        if(this.router.url == '/digital_coach/workout_builder') pearUrl = environment.pearBuilderURL;
        this.commonUtil.openOnNewTab(pearUrl + data.token + '&language=' + this.rootScopeData.currentUser.preferredLanguage);
        this.commonUtil.redirectToAvailablePage();
      },
      error => {
        console.error('API failed.');
        this.commonUtil.redirectToAvailablePage();
      }
    );

  }

}
